import { render, staticRenderFns } from "./discussionHall.vue?vue&type=template&id=787ff8e6&scoped=true"
import script from "./discussionHall.vue?vue&type=script&lang=js"
export * from "./discussionHall.vue?vue&type=script&lang=js"
import style0 from "./discussionHall.vue?vue&type=style&index=0&id=787ff8e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787ff8e6",
  null
  
)

export default component.exports